<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("bc_platform_connect") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
			<div class="row">
				<div class="col-xl-4 text-center">
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
				  <h5 slot="header" class="h3 mb-0">Tiktok</h5>
				  <div class="row">
					<div class="col-md-12">
						<img src="/img/tiktok.png" width="150px" height="150px">
					</div>
				  </div>

                    <div class="row mt-3 px-3">
                        <div class="col-md-12">
							<base-input placeholder="Seller">
								<el-select v-model="TiktokSeller" label="Seller"  placeholder="Seller" value-key="id">
									<el-option v-for="option in tableTiktokeSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
								</el-select>
							</base-input>
						</div>
					</div>

                    <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon class="btn btn-icon" @click="handleConnect('tiktok')"> Connect </base-button>
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('tiktok')"> Sync Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('tiktok')"> Sync Product </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleRefreshToken('tiktok')"> Token </base-button>
						</div>
					</div>

					<div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('tiktok')">Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('tiktok')">Product </base-button>
						</div>
					</div>
                </card>
				</div>

				<div class="col-xl-4 text-center">
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
				  <h5 slot="header" class="h3 mb-0">Lazada</h5>
				   <div class="row">
					<div class="col-md-12"> <img src="/img/lazada.png" width="150px" height="150px"> </div>
				  </div>

				  <div class="row mt-3 px-3">
                        <div class="col-md-12">
							<base-input placeholder="Seller">
								<el-select v-model="LazadaSeller" label="Seller"  placeholder="Seller">
									<el-option v-for="option in tableLazadaSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
								</el-select>
							</base-input>
						</div>
					</div>

                   <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon class="btn btn-icon" @click="handleConnect('lazada')"> Connect </base-button>
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('lazada')"> Sync Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('lazada')"> Sync Product </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleRefreshToken('lazada')"> Token </base-button>
						</div>
					</div>

					<div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('lazada')">Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('lazada')">Product </base-button>
						</div>
					</div>
                </card>
				</div>

				<div class="col-xl-4 text-center">
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
				  <h5 slot="header" class="h3 mb-0">Shopee</h5>
				  <div class="row">
					<div class="col-md-12">
						<img src="/img/shopee.png"  width="150px" height="150px">
					</div>
				  </div>

				  <div class="row mt-3 px-3">
                        <div class="col-md-12">
							<base-input placeholder="Seller">
								<el-select v-model="ShopeeSeller" label="Seller"  placeholder="Seller">
									<el-option v-for="option in tableShopeeSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
								</el-select>
							</base-input>
						</div>
					</div>

                    <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon class="btn btn-icon" @click="handleConnect('shopee')"> Connect </base-button>
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('shopee')"> Sync Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('shopee')"> Sync Product </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleRefreshToken('shopee')"> Token </base-button>
						</div>
					</div>

					<div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('shopee')">Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('shopee')">Product </base-button>
						</div>
					</div>
                </card>
				</div>
			</div>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/TiktokclientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableData: "Tiktok/getOrders",
            tableSeller: "Platform/getSellers"
        }),
		tableTiktokeSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 2
			})
		},
		tableLazadaSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 4
			})
		},
		tableShopeeSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 3
			})
		},
        tableColumns: function() {
            return [
                {
                    prop: "ProductName",
                    label: this.$t("wms.product"),
                    minWidth: 90,
                    sortable: true
                },

                {
                    prop: "StorageName",
                    label: this.$t("wms.storage"),
                    minWidth: 100,
                    sortable: true
                },
                {
                    prop: "Balance",
                    label: this.$t("wms.balance"),
                    minWidth: 120,
                    sortable: true
                },
                {
                    prop: "OverallAmount",
                    label: this.$t("wms.overall_amount"),
                    minWidth: 90,
                    sortable: true
                }
            ];
        }
    },
    data() {
        return {
            propsToSearch: ["Number", "Email"],
			productLoading:false,
			orderLoading:false,
            selectedRows: [],
            SearchKeyword: "",
            showAddModal: false,
            showInOutModal: false,
            status: 0,
            startDate: "",
            endDate: "",
			TiktokSeller:null,
			LazadaSeller:null,
			ShopeeSeller:null,
            md: {
                InventoryID: 0,
                ProductID: "-",
                StorageID: "-",
                Note: "",
                Quantity: "0",
                Cost: 0
            },
            inOut: {
                InventoryID: 0,
                ProductID: 0,
                StorageID: 0,
                Note: "",
                Quantity: 0,
                Cost: 0,
                Action: ""
            },
            rowEdit: {
                ID: 0,
                Number: ""
            },

            OrderStatus: [
                { ID: 0, Name: "All" },
                { ID: 100, Name: "Unpaid" },
                { ID: 111, Name: "AwaitingShipment" },
                { ID: 112, Name: "AwaitingCollection" },
                { ID: 114, Name: "PartiallyShipping" },
                { ID: 121, Name: "InTransit" },
                { ID: 122, Name: "Delivered" },
                { ID: 130, Name: "Completed" },
                { ID: 140, Name: "Cancelled" }
            ],
			PlatformTable: [
				{id:1,name:"madamefin"},
				{id:2,name:"tiktok"},
				{id:3,name:"shopee"},
				{id:4,name:"lazada"},
				{id:5,name:"line"},

			]
        };
    },
    mounted() {
		this.SellerList()

	},
    methods: {
        ...mapActions({
            // InventoryIn: "Inventory/InventoryIn",
            // InventoryOut: "Inventory/InventoryOut",
            // InventoryDelete: "Inventory/InventoryDelete",
            // listData: "Tiktok/GetOrderList",
            // getShippingDocument: "Tiktok/GetShippingDocument",
            syncProduct: "Platform/SyncProduct",
            syncOrder: "Platform/SyncOrder",
            ConnectPlatform: "Platform/ConnectPlatform",
            SellerList: "Platform/listSeller",
			RefreshToken: "Platform/RefreshToken",
        }),
		GetPlatformID(platform) {
			let platform_id = 0
			this.PlatformTable.forEach(v=>{
					console.log(v.name)
				if (v.name == platform)
				{
					platform_id = v.id
				}
			})

			return platform_id
		},

		handleOrder(platform){
				this.$router.push({ path: `/backoffice/orders?platform=${platform}` });
		},
		handleProduct(platform){
				this.$router.push({ path: `/admin/product/${platform}` });

		},

		handleSyncOrder(platform){

			let params = {
				platform : platform,
				open_id : "",
				shop_id : "",
				shop_name : "",
			}

			try {
				switch (platform)  {
					case "tiktok" : 
					 	params.open_id = this.TiktokSeller.open_id; 
					 	params.shop_id = this.TiktokSeller.shop_id; 
					 	params.shop_name = this.TiktokSeller.shop_name; 
					
					break
					case "shopee" : 
						params.open_id = this.ShopeeSeller.open_id; 
					 	params.shop_id = this.ShopeeSeller.shop_id; 
					 	params.shop_name = this.ShopeeSeller.shop_name; 
					break
					case "lazada" :
						params.open_id = this.LazadaSeller.open_id;
					 	params.shop_id = this.LazadaSeller.shop_id; 
					 	params.shop_name = this.LazadaSeller.shop_name; 
						break
				}
			}
			catch (err){
				console.log(err)
				swal.fire({
                    title: "กรุณาเลือก Seller",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return

			}

			this.syncOrder(params).then(resp=>{
				this.$router.push({ path: `/backoffice/orders?platform=${platform}` });
			}).catch(err=>{

				console.log("error",err)
				this.orderLoading = false
				swal.fire({
                    title: this.$t(err.response.data),
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
			})
		},
		handleRefreshToken(platform){
			let params = {
				platform : platform,
				shop_id : ""
			}

			try {
				switch (platform)  {
					case "tiktok" : params.shop_id = this.TiktokSeller.shop_id; break
					case "shopee" : params.shop_id = this.ShopeeSeller.shop_id; break 
					case "lazada" :params.shop_id = this.LazadaSeller.shop_id; break
				}
			}
			catch (err){
				console.log(err)
				swal.fire({
                    title: "กรุณาเลือก Seller",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return
			}

			if (params.shop_id == "") {
				swal.fire({
					title: "กรุณาเลือก Seller",
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return
			}

			this.RefreshToken(params).then(resp=>{
				swal.fire({
					title: "Refresh Token Success",
					text: "",
					icon: "success",
					confirmButtonClass: "btn btn-primary btn-fill",
					buttonsStyling: false
				});


			}).catch(err=>{
				swal.fire({
                    title: this.$t(err.response.data.Msg),
                    text: err,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
			});

		},
		handleSyncProduct(platform){

			let params = {
				platform : platform,
				shop_id : ""
			}

			try {
				switch (platform)  {
					case "tiktok" : params.shop_id = this.TiktokSeller.shop_id; break
					case "shopee" : params.shop_id = this.ShopeeSeller.shop_id; break 
					case "lazada" :params.shop_id = this.LazadaSeller.shop_id; break
				}
			}
			catch (err){
				console.log(err)
				swal.fire({
                    title: "กรุณาเลือก Seller",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return

			}

			this.syncProduct(params).then(resp=>{

			this.productLoading = false
				this.$router.push({ path: `/admin/product/${platform}` });
			}).catch(err=>{
			this.productLoading = false
				swal.fire({
                    title: $t("err.response.data.Msg"),
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });

			});
		},
		handleConnect(platform){
			let id = this.GetPlatformID(platform)
			this.ConnectPlatform(id).then(resp=>{
				window.open(resp.data)
			}).catch(err=>{
				console.log(err)
				swal.fire({
                    title: "Can't connect platform",
                    text: err.respone,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
				})
			})

		}
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
